export default __webpack_public_path__ + "static/media/undraw_adventure_4hum 1.182b6171.svg";